import { render } from "./CompleteView.vue?vue&type=template&id=2a85cc10&scoped=true"
import script from "./CompleteView.vue?vue&type=script&lang=js"
export * from "./CompleteView.vue?vue&type=script&lang=js"

import "./CompleteView.vue?vue&type=style&index=0&id=2a85cc10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a85cc10"]])

export default __exports__